import { EventHint } from '@sentry/react'
import { AxiosError, isAxiosError } from 'axios'

type AxiosErrorCode = typeof AxiosError.ECONNABORTED

export const isAxiosErrorWithCode = (hint: EventHint, code: AxiosErrorCode): boolean =>
  isAxiosError(hint.originalException) && hint.originalException.code === code
